
import axios from '@/store/config';
import { CONTRACT_STATUSES } from '@/config/constants'
import { findIndex, pick } from 'lodash'

export default {
  // state
  state : {
    measures: [],
    cart: [],
    previousorders: [],
  },
  // getters
  getters : {
    measures: state => {
      return state.measures;
    },

    cart: state => {
      return state.cart;
    },

    previousorders: state => {
      return state.previousorders;
    }
  },

  // actions
  actions : {

    /**
     * Hämta alla bevakningar på inloggad användare
     */

    fetchMeasures ({ commit }, code) {
      return axios.get('/maintenance/'+ code +'/measures')
      .then((response) => {
        const data = response.data.map((measures) => {
          measures.code = measures.room + "-" + measures.measurementCode;
          return measures
        })
        commit('setMeasures', data);
        return data;
      })
    },


    fetchCart ({ commit }, code) {
      return axios.get('/maintenance/'+ code +'/measures/cart')
        .catch(function (error) {
        })
        .then((response) => {
          commit('setCart', response.data.current.articles);
          commit('setPreviousOrders', response.data.previous);

          return response.data.current.articles;
        })
    },

    /**
     * Hämtar data från Passad på det första lägenhets nr kontraktet.
     */
    getApartmentNumber ({ commit, state, rootState, getters, dispatch}) {
      return this.cache.dispatch('fetchContracts').then(() => {
        if(getters.hasApartment){
          return getters.getApartments[0].rentalObjectCode;
        }else {
          return false;
        }
      })
    },

    /**
     * Hämtar alla lägenhetsnummer
     */
    getApartmentNumbers ({ commit, state, rootState, getters, dispatch}) {
      return this.cache.dispatch('fetchContracts').then(() => {
        if(getters.hasApartment){
          let res = getters.getApartments.filter(c => {
            // Filterar ut de kontrakt som inte är av rätt typ
            return ['LGH1', 'LGH2', 'LGH4'].some(s => s == c.rentalObject.rentalObjectTypeCode);
          });
          res = res.filter(c => {
            // Filterar ut de kontrakt som inte är av rätt typ
            return [CONTRACT_STATUSES.VALID, CONTRACT_STATUSES.COMING].some(s => s == c.status);
          });

          return res.map(item => {
            if (item.status === CONTRACT_STATUSES.COMING) {
              item.textstatus = 'Kommande';
            }else if (item.status === CONTRACT_STATUSES.VALID) {
              item.textstatus = 'Gällande';
            } else if(item.status == CONTRACT_STATUSES.PRELIMINARILYTERMINATED){
              item.textstatus = "Preliminärt avslutat";
            }
            return item;
          });

        }else {
          return false;
        }
      })
    },

    addToCart ({ commit }, obj) {
      commit('add', obj.code);

      return axios.post('/maintenance/'+obj.contract+'/measures/cart/current/articles', {"add": [obj.code]})
        .then((response) => {
          return response;
        });
    },

    removeFromCart ({ commit}, obj) {
      commit('remove', obj.code);

      return axios.post('/maintenance/'+obj.contract+'/measures/cart/current/articles', {"remove": [obj.code]})
        .then((response) => {
          return response;
        });
    },

    finalizeCart ({ commit}, obj) {
      return axios.post('/maintenance/'+obj.contract+'/measures/cart/current/finalize',{ "state" : "complete" })
        .then((response) => {
          return response;
        });
    },
},

  // mutations
  mutations : {
    setMeasures (state, measures) {
      state.measures = measures;
    },
    setCart (state, cart) {
      state.cart = cart;
    },
    setPreviousOrders (state, orders) {
      state.previousorders = orders;
    },

    add (state, item) {
      state.cart.push(item);
    },

    remove (state, item) {
      const index =  state.cart.indexOf(item);
      if (index > -1) {
        state.cart.splice(index, 1);
      }
     },
  }
}
